import React from 'react';
import { connect } from 'react-redux';
import { utils } from '../../_helpers';
import { currencyServices , transactionService } from '../../_services';
import { Link } from 'react-router-dom';
import { BuyForm } from './BuyForm'
import { SellForm } from './SellForm'
import { TradeHistoryTable } from './TradeHistoryTable'

class ExchangePage extends React.Component {

    constructor(props){
        super(props); 

        this.state = {
            listingForBuy : [] , 
            listingForSell : [] , 
            listingForBuy_LastUpdated : '' , 
            listingForSell_LastUpdated : '' , 
            latestSuccessfulOrderList : null , 
            order : {}  , 
            formType : null
        }
    }

    componentDidMount(){
        
        const { authentication } = this.props;
        let id = authentication.user.id;

        //get exchange page data 
        transactionService.getExchangepageData(id)
        .then (response => {
            if(response){
                this.setState({
                    listingForBuy_LastUpdated : response.listingForBuy_lastUpdated , 
                    listingForBuy : response.listingForBuy , 
                    listingForSell_LastUpdated : response.listngForSell_lastUpdated , 
                    listingForSell : response.listingForSell , 
                    latestSuccessfulOrderList : response.latestSuccessfulOrders
                })
            }
        })
    }

    handleClickBuy(record , formtype){
        if(record){

            this.setState({
                order : record , 
                formType : formtype
            })
        }
    }

    render(){
        const {wallet} = this.props;
        const {listingForBuy , listingForBuy_LastUpdated , listingForSell , listingForSell_LastUpdated ,
            latestSuccessfulOrderList, order , conversion} = this.state;

        return (
            <section className="section m-b-lg">
                <div className="container">
                    <div className="columns is-mobile border-bottom p-b-xs">
                        <div className="column is-6-desktop is-6-mobile">
                            <div className="columns exchangeheader">
                                
                                <div className="column is-6">
                                    <div className="field">
                                        <p className="control has-icons-right">
                                            <input className="input" type="text" placeholder="Search ..." />
                                            <span className="icon is-small is-right">
                                                <i className="fas fa-search"></i>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="column is-6-desktop is-6-mobile is-clearfix p-t-md">
                            {
                                 wallet.userwallet &&
                                 <div className="columns exchangeheader">
                                    {
                                        wallet.userwallet.length > 0 ?
                                        (
                                            <React.Fragment>
                                            <h6 className="column v-centered border-right-bold light">My Wallet</h6>
                                            {
                                                Array.isArray(wallet.userwallet) && 
                                                wallet.userwallet.map((walletitem)=>{
                                                    return (
                                                        <div key={walletitem.currency} className="column border-right p-l-md">
                                                            <span className="light-text">{walletitem.currency}</span> 
                                                            <br/>
                                                            <h6 className="light">{utils.addZeroes(walletitem.balance.toString())}</h6>
                                                        </div>
                                                    )
                                                })
                                            }
                                            </React.Fragment>
                                        )
                                        :
                                        (
                                            <p className="column has-text-right">
                                                Current wallet is empty . Please <a href="/account/deposit">deposit here</a> 
                                            </p>
                                        )
                                    }

                                    </div>
                            }
                            
                        </div>
                    </div>

                    <div className="columns is-mobile m-t-md ">
                        <div className="column is-4-desktop is-6-mobile boxmain-single border-right p-r-lg">
                            {
                                this.state.formType && 
                                (
                                    this.state.formType === 'buyform' ? 
                                    (
                                        <BuyForm order={order}/>
                                    )
                                    :
                                    (
                                        <SellForm order={order}/>
                                    )
                                )
                            }
                            
                            <h4>latest successful orders</h4>
                            
                            <TradeHistoryTable list = {latestSuccessfulOrderList}/>
                        </div>
                        <div className="column is-8-desktop is-6-mobile boxmain-single">
                            <h4>buy orders

                                <div className="is-pulled-right mini-data">
                                    {listingForSell_LastUpdated}
                                </div>
                            </h4>
                            <div className="table-container">
                                <table className="table tbl-exchange is-fullwidth m-t-md ">
                                    <thead className="green">
                                        <tr>
                                            <th>Member</th>
                                            <th>Asset</th>
                                            <th>Price / Asset</th>
                                            <th>Min</th>
                                            <th>Size</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {
                                        listingForSell && 
                                        <tbody>
                                        {
                                            listingForSell.length > 0 && 
                                            listingForSell.map((record) => {
                                                return (
                                                    <tr key={record.id}>
                                                        <td>{record.memberName}</td>
                                                        <td>{record.coin}</td>
                                                        <td>{record.currency} {record.rate}</td>
                                                        <td>{record.coin} {record.min}</td>
                                                        <td>{record.coin} {record.size}</td>
                                                        <td>{record.status}</td>
                                                        <td><button className="button btn-buy is-small" onClick={()=> this.handleClickBuy(record , 'sellform')}>Sell</button></td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    }
                                </table>
                               
                            </div>
                           
                            <div className="border-bottom p-t-md m-b-lg"></div>
                            
                            <h4>sell orders

                                <div className="is-pulled-right mini-data">
                                    {listingForBuy_LastUpdated}
                                </div>
                            </h4>
                            <div className="table-container">
                                <table className="table tbl-exchange is-fullwidth m-t-md ">
                                    <thead className="green">
                                        <tr>
                                            <th>Merchant</th>
                                            <th>Asset</th>
                                            <th>Price / Asset</th>
                                            <th>Min</th>
                                            <th>Size</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {
                                        listingForBuy && 
                                        <tbody>
                                            {
                                                listingForBuy.length > 0 && 
                                                listingForBuy.map((record) => {
                                                    return (
                                                        <tr key={record.id}>
                                                            <td>{record.memberName}</td>
                                                            <td>{record.coin}</td>
                                                            <td>{record.currency} {record.rate}</td>
                                                            <td>{record.coin} {record.min}</td>
                                                            <td>{record.coin} {record.size}</td>
                                                            <td>{record.status}</td>
                                                            <td><button className="button btn-buy is-small" onClick={()=> this.handleClickBuy(record , 'buyform')}>Buy</button></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    const { wallet , authentication } = state;
    return {
        wallet , authentication
    };
}

const connected = connect(mapStateToProps)(ExchangePage);
export { connected as ExchangePage }; 



// WEBPACK FOOTER //
// ./src/Views/ExchangePage/ExchangePage.jsx